module.exports = __webpack_public_path__ + "img/if_3.5224f95e.png";